import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { removeMultipleSlashes } from "../../data/sport-utils";
import { XRouterNavigateContext } from "../seo/xrouter/XRouterNavigateContext";
import { usePrematchData } from "../../prematch/PrematchDataProvider";
import { getConfiguration } from '../../data/utils/configuration';
import { getDBTimestampFromDate } from '../../data/utils/getDBTimestampFromDate';
import { getPrematchAggs } from '../../data/utils/getPrematchAggs';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';

export const SwiperSportsWh = () => {
    const prematchData = usePrematchData();
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const conf = getConfiguration();
    
    let modelSports = JSON.parse(conf.mbtns || '[]');

    const navigateToSport = (sportId) => {
        const today = getDBTimestampFromDate(new Date()).slice(0, 8);
        let aggs = getPrematchAggs(sportId);
        aggs = Array.from(Object.values(aggs));
        const agg = getPrincipaleOPrimoGruppo(aggs);
        const aggId = agg.idAggregata;
        const destination = removeMultipleSlashes(`/betting/it-it/g/tutte/${today}/${sportId}/${aggId}`);
        const sportData = prematchData.sportById[sportId];

        if (sportData) {
            xrouterNavigateContext.navigate(destination, { data: sportData });
        } else {
            console.error("Sport data not found for sportId", sportId);
        }
    };

    const handleClick = (item) => {
        const { sportId, url } = item;

        if (sportId && sportId !== 0) {
            navigateToSport(sportId);
        } else if (url) {
            window.location.href = url;
        }
        else if (sportId == 0) {
            console.log("Errore: sportId è 0");
        }
        else {
            console.error("URL non definito:", item);
        }
    };

    return (
        <>
            <div className="swiper__sports--container">
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    modules={[Pagination]}
                    className="swiper__items"
                >
                    {modelSports?.map((i, index) => (
                        <SwiperSlide key={index}>
                            <div className="swiper__items--wrapper--sports ">
                                <div className="swiper__items__content--wrapper--sports">
                                    <div onClick={() => handleClick(i)} className="swiper__items__content--sport flex flex-col items-center">
                                        <div className="swiper__items__content--icon">
                                            <img className={`${i.url ? 'external__products' : 'sports__products'}`} src={i.img}></img>
                                        </div>
                                        <div className="swiper__items__content--title--sports">
                                            {i.desc.IT}
                                        </div>
                                    </div>
                                </div>
                            </div>{" "}
                        </SwiperSlide>
                    ))}
                </Swiper></div>
        </>
    );
};

export default SwiperSportsWh;
